import { Alert, AlertIcon, Button, Icon, Stack, Text } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { FiExternalLink } from "react-icons/fi";
import { Link as RouterLink } from "react-router-dom";
import { type MarketDialogueProcurementDto } from "../../autogen/bff-api";
import { procurementEntryHref } from "../sourcing-event/procurementEntryHref";

export const MarketDialogueProcurementsNotice = ({ procurements }: { procurements: MarketDialogueProcurementDto[] }) => {
  const { t } = useTranslation();
  if (procurements.length === 0) return null;
  return (
    <Alert status="info" borderRadius="md" mt="4" alignItems="flex-start" data-testid="market-dialogue-procurements">
      <AlertIcon />
      <Stack spacing="2" flex="1" minW="0" fontSize="sm">
        <Text>{t("Procurements created from this market dialogue:")}</Text>
        <Stack as="ul" listStyleType="none" spacing="1" align="flex-start">
          {procurements.map((procurement) => (
            <li key={procurement.id}>
              <Button
                as={RouterLink}
                to={procurementEntryHref(procurement.status, procurement.id)}
                target="_blank"
                rightIcon={<Icon as={FiExternalLink} />}
                variant="link"
                size="sm"
                colorScheme="teal"
                textAlign="left"
                whiteSpace="normal"
              >
                {procurement.title.trim() || t("Untitled")}
              </Button>
            </li>
          ))}
        </Stack>
      </Stack>
    </Alert>
  );
};
